<template>
  <span class="ui-badge" :class="`ui-badge-${variant}`">
    <slot />
  </span>
</template>

<script>
export default {
  name: 'UiBadge',
  props: {
    variant: {
      type: String,
      default: 'secondary'
    }
  }
}
</script>

<style scoped>
.ui-badge {
  display: inline-flex;
  align-items: center;
  width: fit-content;
  min-height: 22px;
  padding: 0 8px;
  border: 1px solid hsl(var(--border));
  border-radius: 999px;
  font-size: 0.72rem;
  font-weight: 800;
  line-height: 1;
  white-space: nowrap;
}

.ui-badge-secondary {
  background: hsl(var(--secondary));
  color: hsl(var(--foreground));
}

.ui-badge-outline {
  background: transparent;
  color: hsl(var(--muted-foreground));
}

.ui-badge-success {
  border-color: hsl(142 64% 28%);
  background: hsl(142 64% 16%);
  color: hsl(142 70% 64%);
}

.ui-badge-warning {
  border-color: hsl(38 90% 28%);
  background: hsl(38 90% 14%);
  color: hsl(38 92% 62%);
}

.ui-badge-info {
  border-color: hsl(217 80% 30%);
  background: hsl(217 80% 16%);
  color: hsl(217 90% 68%);
}
</style>
